import PriceAdvisorContainer from './PriceAdvisor.container';
import MarketPrice from './components/MarketPrice';
import PriceAdvisor from './components/PriceAdvisor';

export { PriceAdvisor, MarketPrice };

export default PriceAdvisorContainer;
